import type { SimulationState, CEOParams, ThemeData, PrestigeBonuses } from '../types';
import { createCompany, DEFAULT_PRESTIGE_BONUSES } from '../entities/CompanyFactory';
import { createCEO } from '../entities/StaffFactory';
import { getOffice } from '../entities/OfficeFactory';
import { createCompetitors } from '../entities/CompetitorFactory';
import { generateContractPool } from '../entities/ContractFactory';
import type { SeededRandom } from '../rng/SeededRandom';

export function createInitialState(
  companyName: string,
  ceo: CEOParams,
  themeData: ThemeData,
  rng: SeededRandom,
  prestigeBonuses: PrestigeBonuses = DEFAULT_PRESTIGE_BONUSES,
  isHardMode: boolean = false,
): SimulationState {
  const company = createCompany(companyName, ceo, themeData, prestigeBonuses, isHardMode);
  const ceoStaff = createCEO(ceo.name, ceo.appearance, ceo.bonusStats, themeData);
  const office = getOffice(1, themeData);
  const competitors = createCompetitors(themeData, rng);
  const contractPool = generateContractPool(rng, themeData, 1);

  return {
    company,
    staff: [ceoStaff],
    teams: [],
    projects: [],
    products: [],
    contracts: [],
    competitors,
    office,
    hiringPool: [],
    contractPool,
    activeRecruiter: null,
    loans: [],
    purchasedEquipment: [],
    achievements: [],
    timeline: [],
    marketTrends: { ...themeData.entities.categoryComboAffinity },
    unlocks: [...prestigeBonuses.unlockedFromStart],
    speed: 1,
    isPaused: false,
    tutorialTipsShown: [],
    tickCatchUpEnabled: true,
  };
}
